<template>
  <loading v-if="loading" />
  <div v-else>
    <div class="p-2">
      <wd-filter @filter-input="updateFilter" :filter-array="['title', 'activity_category_id']" />
    </div>
    <div class="stack-sm overflow-y-auto" v-if="filteredActivities.length > 0">
      <activity
        v-for="activity in filteredActivities"
        :key="activity.id"
        :activity="activity"
        :category="getCategory(activity.activity_category_id)"
      />
    </div>
    <div class="mt-4 text-center italic text-lg" v-else>{{ $t('activities.no_activity_found') }}</div>
    <fab @input="openCreateActivity">
      <icon name="Plus" />
    </fab>
  </div>
</template>

<script>
const Activity = require("@/modules/activities/components/Activity.vue")
  .default;
const WdFilter = require("@/modules/core/components/WdFilter.vue").default;
const Fab = require("@/modules/core/components/Fab.vue").default;

import { ActivityModel } from "@/modules/activities/viewmodels/Activity";
import { ActivityCategory } from "../viewmodels/ActivityCategory";

export default {
  name: "ActivitiesManageSite",
  data() {
    return {
      allVisible: true,
      filters: {
        title: "",
        activity_category_id: null
      },
      activities: [],
      activityCategories: []
    };
  },
  props: {},
  components: {
    Activity,
    WdFilter,
    Fab
  },
  methods: {
    setVisibility(Bool) {
      this.allVisible = Bool !== undefined ? Bool : !this.allVisible;
    },
    updateFilter(FilterObj) {
      this.filters = FilterObj;
    },
    openCreateActivity() {
      this.$router.push("/create-activity");
    },
    getCategory(Id) {
      return this.activityCategories
        ? new ActivityCategory(this.activityCategories.find(e => e.id === Id))
        : false;
    }
  },
  computed: {
    userActivities() {
      let userActivities = this.$store.getters["useractivity/userActivities"];
      return userActivities !== null
        ? userActivities.map(e => {
            if (e.activity !== undefined) {
              return new ActivityModel(e.activity);
            }
            return new ActivityModel(
              this.$store.getters["activity/activity"](e.activity_id)
            );
          })
        : false;
    },
    filteredActivities() {
      let elements = this.allVisible ? this.activities : this.userActivities;

      if (
        this.filters.activity_category_id &&
        this.filters.activity_category_id !== "all"
      ) {
        elements = elements.filter(
          e => e.activity_category_id === this.filters.activity_category_id
        );
      }

      if (this.filters.title) {
        elements = elements.filter(e =>
          e.title.toUpperCase().includes(this.filters.title.toUpperCase())
        );
      }

      return elements;
    }
  },
  async created() {
    this.activityCategories = await this.$store.getters[
      "activitycategory/api"
    ].GetAll();
    this.activities = await this.$store.getters["activity/api"].Custom.AllMy();
    await this.$store.getters["useractivity/api"].Custom.My();

    this.$store.dispatch("header/update", {
      backbutton: true,
      clear: true,
      tabs: {
        elements: [
          {
            bright: true,
            title: this.$t("activities.all"),
            action: () => {
              this.setVisibility(true);
            }
          },
          {
            bright: true,
            title: this.$tc("activities.favorite", 2),
            action: () => {
              this.setVisibility(false);
            }
          }
        ]
      },
      elements: [
        {
          value: this.$t("activities.my_activities"),
          css: "tracking-wider font-medium"
        }
      ]
    });
    this.loaded();
  }
};
</script>
